/** @jsx jsx */
import React, {useState, useEffect} from "react";
import { css, jsx } from "@emotion/core";
import { Dropdown } from 'react-bootstrap';
import ClickableButton from "components/atoms/ClickableIconButton";
import HeaderBar from "components/atoms/HeaderBar";
import FlexBox from "components/atoms/FlexBox";
import FlexBoxItem from "components/atoms/FlexBoxItem";
import PrimaryLogo from "components/atoms/Logo/Primary";
import PhotoFrame from "components/molecules/PhotoFrame";
import { useStaffSetting } from "./hooks";
import StaffSettingPanel from "./StaffSettingPanel";
import usePhotoPath from "hooks/usePhotoPath";
import { Link } from "react-router-dom";
import Icon from "components/atoms/Icon";
import { grayScale } from "components/styles";
import useLoginUser from "hooks/useLoginUser";
import useComponentVisible from "hooks/useComponentVisible";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';
import { HamburgerButton } from "components/atoms/Button";
// import Dropdown from "components/molecules/Dropdown";
import { DropdownItemProps } from 'components/molecules/Dropdown/DropdownItem';
import IconLabelButton from "components/molecules/IconLabelButton";
// import SecondaryLogo from "components/atoms/Logo/Secondary";

/**
 * アプリケーション共通のヘッダーバー
 */
const LOCAL_STORAGE_SHOP_INFO_KEY_NAME = 'win-board-localstorage-shop-info';

type SelectType = "id" | "face" | "gps";

const SelectType: { [key in SelectType]: SelectType } = {
	id: "id",
	face: "face",
	gps: "gps"
};

const styles = {
  text: css({
    fontSize: '12px!important',
    textAlign: 'center',
    cursor: "pointer",
    color: `${grayScale.gray60}!important`,
    ':hover':{
      color: `${grayScale.gray100}!important`
    }
  }),
  icon: css({
    'span': {
    fontSize: '12px!important',
    textAlign: 'center',
    cursor: "pointer",
    color: `${grayScale.gray60}!important`,
    ':hover':{
      color: `${grayScale.gray100}!important`
    }
    }
  })
};

const Appbar: React.FC<{}> = ({}) => {
  const { logoutAction } = useStaffSetting();
  const { myPhotoPath } = usePhotoPath();
  const photoPathGlobal = useSelector((state:Store) => state.ui.appBar.photoPath);
  const collapsedSidebar = useSelector((state:Store) => state.ui.appBar.collapsedSidebar);
  const recorder = useSelector((state:Store) => state.ui.recorder.recorder);
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
  const history = useHistory();
  const shopCodeSpecify = localStorage.getItem(LOCAL_STORAGE_SHOP_INFO_KEY_NAME);
  const isLogin = useLoginUser().staffName ? 1 : 0;
  const showFaceStamp = sessionStorage.getItem("loginUser.useFaceStamp") === "true" ? true : false;
  const showIdStamp = sessionStorage.getItem("loginUser.useBarcodeStamp") === "true" ? true : false;
  const showGpsStamp = sessionStorage.getItem("loginUser.useGpsStamp") === "true" ? true : false;

  // Inside Flag Recorder
  const showInsideFaceStamp = sessionStorage.getItem("loginUser.useInsideLoginFaceRecorderStamp") === "true" ? true : false;
  const showInsideIdStamp = sessionStorage.getItem("loginUser.useInsideLoginBarcodeStamp") === "true" ? true : false;

  const userRole = sessionStorage.getItem('loginUser.site') || "1";
  const defaultPageUrl = '/agreement36';
  const logoFlag = process.env.REACT_APP_LOGO_FLAG;

  const dismissAll = () =>  toast.dismiss();
  const isPhone = window.matchMedia("(max-width: 480px)").matches;
  const dataUserLogin = useSelector((state: Store) => state.ui.appBar.loginUser);

  return (
    <HeaderBar>
      <FlexBox 
        justifyContent="space-between" 
        customStyle={css({width: '100%', maxWidth: '1440px', margin: 'auto'})}
      >
        <FlexBoxItem>
          <FlexBox>
            {
              !isPhone && ( 
                <FlexBoxItem 
                  customStyle={css({
                    maxWidth: collapsedSidebar ? "45px" : "230px",
                    width: "230px",
                    // transition: 'max-width 0.3s linear',
                  })}
                >
                  <Link to={defaultPageUrl} onClick={dismissAll}>
                    {
                      logoFlag === "0"
                      ? <img 
                          src="/menu_logo.gif" 
                          css={css({ height: "4.3rem" })} 
                        />
                      : <img 
                          src="/wsp_01.png" 
                          css={css({ 
                            maxHeight: collapsedSidebar ? "40px" : "3.5rem",
                            height: "3.5rem",
                            transition: 'max-height 0.3s linear',
                          })} 
                        />
                    }
                  </Link>
                </FlexBoxItem>
              )
            }
            <FlexBoxItem customStyle={css({paddingLeft: '15px'})}>
              {isLogin ? <HamburgerButton/> : null}
            </FlexBoxItem>
          </FlexBox>
        </FlexBoxItem>

        <FlexBox customStyle={css({position:'relative'})}>
          {
            isLogin ? (
              <FlexBoxItem 
                margin="0 0 6px 1rem" 
                customStyle={css({marginRight: '-10px', marginTop: '7px'})}
              >
                {(recorder?.useInsideLoginBarcodeStamp || recorder?.useInsideLoginFaceRecorderStamp || recorder?.useGpsStamp) ? 
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <IconLabelButton 
                      onClick={() => {}} 
                      iconType="timeRecorder"
                      text="打刻"
                      margin='auto' 
                      customStyle={styles.icon}
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{width: '100px'}}>
                     {recorder?.useInsideLoginBarcodeStamp ? 
                     <Dropdown.Item
                        disabled={false}
                        className="timeRecorder"
                        css={styles.text}
                        key="id"
                        onClick={()=> history.push('/recorder/id')}
                      >ID
                      </Dropdown.Item>: ''}
                      {recorder?.useInsideLoginFaceRecorderStamp ?
                      <Dropdown.Item
                        disabled={false}
                        className="timeRecorder"
                        css={styles.text}
                        key="face"
                        onClick={()=> history.push('/recorder/face')}
                      >顔認証
                      </Dropdown.Item>: ''}
                      {recorder?.useGpsStamp ? 
                      <Dropdown.Item
                        disabled={false}
                        className="timeRecorder"
                        css={styles.text}
                        key="gps"
                        onClick={()=> history.push('/recorder/gps')}
                      >GPS
                      </Dropdown.Item>: ''}
                  </Dropdown.Menu>
                </Dropdown> :""}
              </FlexBoxItem>
            ) : shopCodeSpecify && (
              <FlexBoxItem margin="0 0 6px 1rem">
                <div 
                  className="timeRecorder" 
                  css={css({ textDecoration: "none", cursor: "pointer" })} 
                  onClick={() => history.push(isLogin? "/recorder/id" : "/recorder_1")}
                >
                  <Icon type="timeRecorder" color="" />
                  <span css={css({ fontSize: "12px", marginLeft: "5px", color: grayScale.gray01 })}>
                    タイムレコーダー
                  </span>
                </div>
              </FlexBoxItem>
            )
          }
          
          <FlexBoxItem marginLeft="1rem">
            {/* <SecondaryLogo /> */}
            {
              logoFlag === "0"
              ? <img 
                  alt="Cydas" 
                  src="/menu_logo.gif" 
                  css={css({height: "4.3rem" })} 
                /> 
              : <img 
                  alt="Cydas" 
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAAOCAYAAAB95wG7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATDSURBVHgB5VfNbiJHEP66By7OIbyBcZ6APUTaVWwyKPcEP8HaTwDcLA8RoDVOpBzMPoHJE5jcozAyrDaHSOYNTA65EymWIjMznarumWaGmXWwVjnlk8ae6Z/qquqqrwoBRnfWor99KFQAMUa4HuD7xpKnajf3VTjimuaqiFRncXwwwYdwNnPhoAeBmpYlsIISEyvvbFqFdKYQcoLhYSe7l+ac0jW9VfAQNDBqrODNrwBVy6xTJBPqJ1zWx3gK3dkNrW2SPaPcWQna0wr2SmS7OoEQVaMvFngMOvihsRA4n7Ex/ewuscTD+kXtq89ek0P6WmE7JcaLr/dPcwd5t2SIaKMYKzL4AHuyTY7p6RFyNL6rjzb759daSX0GGgjov4MpPgjSMVw3kkvM4PyWjb2230qdFjrTm9/lnJ/SV5KQk/ycqmLPaZJQ8nzKMeag/Hp2cOIYoVY6+lQ0ICPjKOMxQhSN9e0wpOjpaEmMSRwDtcTFkZ+RL+BrmVoezSc6OqU7KyOzXrx+8ntzZs2eqfA2oy9Fbkkf8jFg5Wzk0SFBSLdZX9p5Dl0GpwnfiHc7IG0pysjpnEZn01MTTco4lvdvI1I/4vJobL+7sxEtb2kZUvKltDP6AK5+FxjQup7+Zj2MDgZphz2Gx5xG28dKenwUIQp9RFjh3yAd174rDHJhzgqllRpyKpGxBq6+/eSClBwUpsk2Lo7aNgKFzEaFcRbiCOzbdXsym/IiZVu51NN8uW0awuB0E6p2o1FSES9E6q0dV+TISB1k1ipshK7DnPcLUQ7bqTPjtKW0GR6OsCtCIuVkv/du344L5xvzIn39L4rMRQj5ZWZ/ZPezvU3Nb978XnNfnKpSO2FYP6CQPiaFO5oM2eMEqkxLetraIZFqLJrVBo9lDnHEp/a9IDQL0adIEiJF6mqpK9pzIFIXKiJzYfr24ygUcXRKmVRXl9LRtXuYoDkIMoHBe4n7nPIU5+9qJTv+8y8LiPI+3nu+HeMSr0Rt8dsf5tubmxAeHm4MC9WfRK7xPN3g8IvfsQuYdL1ZYt1yp3TKopIbcZhHFL8Rd5WodXhP7Ue0goxWurWIIhdpGjFB0Ef3tmnKPii6RFU7SagraRdKyjuhRvh8uCltegNXke0nBYlNtKggX+L/K9j0IfwVLNAnwhW6ujKI7IN7/YjozvRvvEe2CmVd1Knvqp8gpGKw4SLXOOfl8IT+nuj3krrCc1AOxylybOVKK1eJArL7KOjWIamyxFVM+I/cehREUxYVm1pFev2dKUArk1YSPTskKDdfvnHx67c+dgHzR7Y835PyE+KUZdxHuHpdd9bI9S+7QlJF8uaGUDk6bCRw6Q8MV21KM/EZjguk3MSpxdHl45Pylc6C7mxFVdk3+oJ7u6RATEp4NWzleh0pubs8wK7g8tydVeKewrC/yf0NgmCJ50AGdIsxJSrl2nErlog0ov6EuYpTap1UTfq5cnHo5+R5M05/Ny791AqoipZlfuZs6csFIhhIyIKOl5316k0z0wskEKq492Fy4zadbyVZo+gQ7jq5AhYRrm7S2MhUu5Dgkiufrjh+9qE04qr6EL4waxBXP+pw1RNVT0n+fbXQ6xgl5kfRyenLnTLLfn6B+H/hH+lLKIqrL0MiAAAAAElFTkSuQmCC" 
                />
            }
          </FlexBoxItem>

          {
            dataUserLogin && (
              <FlexBoxItem marginLeft="1rem">
                <ClickableButton
                  onClick={() => {
                    setIsComponentVisible(true);
                  }}
                  additionalCss={css({
                    padding: '6px 0px'
                  })}
                >
                  <PhotoFrame 
                    src={photoPathGlobal} 
                    size="32px" 
                    isCircle={true} 
                    onErrorIconColor="black" 
                  />
                </ClickableButton>
              </FlexBoxItem>
            )
          }
          <div 
            ref={ref} 
            css={css({ position: "absolute", top: 0, right: 0})}
          >
            {
              isComponentVisible && 
              <StaffSettingPanel 
                staffName={dataUserLogin?.staffName} 
                logoutAction={logoutAction} 
                setIsComponentVisible={setIsComponentVisible}
              />
            }
          </div>
        </FlexBox>
      </FlexBox>
    </HeaderBar>
  );
};

export default Appbar;
